import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useContext,
} from "react";
import { createClient } from "@supabase/supabase-js";

import { useAcreDapp } from "../../providers/AcreDappProvider/AcreDappProvider";

import useGetPrice from "../../hooks/useGetPrice";
import useProperty from "../../hooks/useProperty";
import { useParams } from "react-router-dom";

import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input/Input";
import { Tooltip } from "flowbite-react";
import RoundedButton from "../RoundedButton/RoundedButton";
import DropdownCurrency from "../DropdownCurrency/DropdownCurrency";
import Toggle from "../Toggle/Toggle";
import AddFunds from "./AddFunds";
import Success from "./Success";

import { HiOutlineInformationCircle } from "react-icons/hi";
import { ArrowUpOnSquareIcon } from "@heroicons/react/24/outline";
import eth from "../../media/eth.png";

const PaymentModal = ({ purchaseType, nextStep, chosenListing }) => {
  const { walletAddress } = useAcreDapp();
  let { listingId } = useParams();
  const property = useProperty(listingId);
  const [selectedCurrencySymbol, setSelectedCurrencySymbol] =
    useState(undefined);
  const [selectedCurrencyImage, setSelectedCurrencyImage] = useState(undefined);
  const [priceInput, setPriceInput] = useState(1);
  const [costCrypto, setCostCrypto] = useState(0);
  const [totalPriceCrypto, setTotalPriceCrypto] = useState(undefined);
  const [totalPriceUsd, setTotalPriceUsd] = useState(undefined);
  const { tokenPrice, errorState } = useGetPrice(
    priceInput ? priceInput : 0,
    selectedCurrencySymbol
  );
  const [listingFee, setListingFee] = useState(0);
  const [offer, setOffer] = useState({
    user_address: "",
    user_offers: [],
  });
  const [updatedListing, setUpdatedListing] = useState({
    ...property[0].listing,
    offer,
  });
  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );
  // TODO -- Need to add state with bid or fixed price number to contract

  useEffect(() => {
    let feeCrypto;
    let feeUsd;
    if (tokenPrice?.USD <= 50000) {
      feeCrypto = costCrypto * 0.035; // FIXME - Results in a number like 0.07. Those 2 decimals are then applied to the result. Need to remove decimals.
      feeUsd = tokenPrice?.USD * 0.035;
      //console.log(feeCrypto.toFixed(2))
      setListingFee(3.5);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD < 100000 && tokenPrice?.USD > 51000) {
      feeCrypto = costCrypto * 0.03;
      feeUsd = tokenPrice?.USD * 0.03;
      setListingFee(3.0);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD > 101000 && tokenPrice?.USD < 250000) {
      feeCrypto = costCrypto * 0.025;
      feeUsd = tokenPrice?.USD * 0.025;
      setListingFee(2.5);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD > 251000 && tokenPrice?.USD < 500000) {
      feeCrypto = costCrypto * 0.02;
      feeUsd = tokenPrice?.USD * 0.02;
      setListingFee(2.0);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD > 501000 && tokenPrice?.USD < 750000) {
      feeCrypto = costCrypto * 0.015;
      feeUsd = tokenPrice?.USD * 0.015;
      setListingFee(1.5);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD > 751000 && tokenPrice?.USD < 1000000) {
      feeCrypto = costCrypto * 0.012;
      feeUsd = tokenPrice?.USD * 0.012;
      setListingFee(1.2);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
    } else if (tokenPrice?.USD > 1000000) {
      feeCrypto = costCrypto * 0.01;
      feeUsd = tokenPrice?.USD * 0.01;
      setListingFee(1);
      setTotalPriceUsd(tokenPrice?.USD + feeUsd);
      return;
    } else {
      return;
    }
  }, [costCrypto, selectedCurrencySymbol]);

  //ANCHOR - Multistep Methods
  const Continue = (e) => {
    e.preventDefault();
    nextStep();
  };
  // Payment functions
  const handlePlaceBid = async () => {
    try {
      console.log("Active Offer", offer);
      let { error } = await supabase
        .from("listings")
        .update({ listing: offer })
        .eq("id", listingId);
    } catch (error) {
      console.log("Oops there has been an error", error);
    }
  };

  let activeForm;
  switch (purchaseType) {
    case "auction":
    case "fixed":
    case "rent":
      activeForm = (
        <>
          <div>
            <div className="flex place-content-center mb-10">
              <h1 className="text-3xl font-bold">
                {purchaseType === "auction"
                  ? "Auction Price"
                  : purchaseType === "fixed"
                  ? "Fixed Price"
                  : purchaseType === "rent"
                  ? "Rental"
                  : "Couldn't fetch Purchase Type"}
              </h1>
            </div>
            <h3 className="text-lg font-bold text-black container mt-4 ml-4">
              {purchaseType === "auction"
                ? "Place a Bid"
                : purchaseType === "fixed"
                ? "Buy Now"
                : purchaseType === "rent"
                ? "Rent Now"
                : "Couldn't fetch Purchase Type"}
            </h3>
            <div className="w-full h-auto inline-flex shadow-sm mt-2 justify-evenly rounded-xl">
              <DropdownCurrency
                className="w-48"
                onClick={(currencyDescriptor) => {
                  console.log(
                    `changing currency to ${currencyDescriptor.symbol}`
                  );
                  setSelectedCurrencySymbol(currencyDescriptor.symbol);
                  setSelectedCurrencyImage(currencyDescriptor.logoURI);
                }}
              />
              <Input
                type="number"
                name="token-price"
                id="token-price"
                placeholder={`5 ${
                  selectedCurrencySymbol ? selectedCurrencySymbol : "ETH"
                }`}
                disabled={false}
                price={true}
                usd={false}
                className={`w-fit` + `h-auto`}
                handleChange={(e) => {
                  setPriceInput(e.target.value);
                  setCostCrypto(e.target.value);
                  setOffer(() => {
                    return {
                      ...property[0]?.listing,
                      offers: [
                        {
                          user_address: walletAddress,
                          user_offers: [priceInput],
                        },
                      ],
                    };
                  });
                }}
              />
              <Input
                type="text"
                name="token-price-usd"
                id="token-price-usd"
                placeholder={
                  true && !errorState
                    ? `$${Number(tokenPrice?.USD).toFixed(2)}`
                    : "$0"
                }
                disabled={false}
                price={true}
                usd={true}
                className={`w-48` + `h-14` + ` ml-16`}
              />
            </div>
            {purchaseType === "rent" ? (
              <div className="w-full mt-6 flex flex-row">
                <div className="w-auto flex flex-grow">
                  <h4 className="font-semibold text-black text-sm w-2/3">
                    Choose NFT for collateral
                  </h4>
                </div>
                <div className="w-auto place-content-end mr-8">
                  <Toggle
                    initialToggleState={false}
                    onToggle={(val) => {
                      console.log(val);
                    }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="divide-y divide-solid divide-slate-400">
              <div className="w-16 mt-12 flex flex-row flex-wrap">
                <h5>Fees</h5>
                <Tooltip
                  content="This is some cool info on fees."
                  placement="top"
                  trigger="hover"
                >
                  <HiOutlineInformationCircle className="ml-2 mt-1" />
                </Tooltip>
                <h5 className=" mt-2 mb-4 font-semibold text-xl">
                  {true && !errorState ? listingFee : "0"}%
                </h5>
              </div>
              <div className="flex flex-wrap">
                <h4 className="mt-4 font-bold text-lg">Total</h4>
                <div className="mt-2 ml-96">
                  <div className="inline-flex">
                    <img
                      className="w-8 h-8 mr-2"
                      src={selectedCurrencyImage ? selectedCurrencyImage : eth}
                    />
                    <h6 className="font-semibold">
                      {!errorState && !NaN ? costCrypto : 0}
                    </h6>
                  </div>
                  <h6 className="ml-8 font-thin text-sm">
                    {!errorState && !NaN
                      ? `$${Number(totalPriceUsd).toFixed(2)}`
                      : `$${0}`}
                  </h6>
                </div>
              </div>
              <div className="flex place-content-center mt-16">
                <div className="mt-6">
                  {purchaseType === "auction" ? (
                    <RoundedButton onClick={handlePlaceBid}>
                      Place a Bid
                    </RoundedButton>
                  ) : null}
                  {purchaseType === "fixed" ? (
                    <RoundedButton >
                      Buy Now
                    </RoundedButton>
                  ) : null}
                  {purchaseType === "rent" ? (
                    <RoundedButton onClick={handlePlaceBid}>
                      Rent Now
                    </RoundedButton>
                  ) : null}
                  <RoundedButton outline={true} onClick={Continue}>
                    {" "}
                    Add Funds{" "}
                  </RoundedButton>
                </div>
              </div>
            </div>
          </div>
        </>
      );
      break;
    default:
      break;
  }

  return <>{activeForm}</>;
};
export default PaymentModal;
